
export default class RunLocation {

    constructor(site, fac) {
        this.site = site;
        this.fac = fac;
    }

    isEqual(otherRunLocation) {
        return otherRunLocation && (this.site === otherRunLocation.site) && (this.fac === otherRunLocation.fac);
    }
}



// WEBPACK FOOTER //
// ./src/utils/RunLocation.js